import React from 'react';
import { IndexRoute, Route } from 'react-router';
import Coupons from './partnerCupons';

export default (
  <Route path="cupons-parceiro">
    <IndexRoute component={props => <Coupons {...props} />} />
  </Route>
);
